var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.content.name))]),_c('p',{staticClass:"time"},[_vm._v("版本："+_vm._s(_vm.content.version)+" ")]),_c('p',{staticClass:"time"},[_vm._v("时间："+_vm._s(_vm.formatDate(_vm.content.createTime)))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.fullText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }